class BESSAppProjectEditorFilterTag extends BESSAppProjectEditorAttributeFilter {
    constructor(editor, container) {
        super(editor,
            container.find('.app-filter-tag'),
            editor.data.tags,
            'tags',
            'Tags'
        );
    }
}